export const PRICE_SERVICE_URL = import.meta.env.VITE_PRICING_API_URL;
